import React from 'react'

// icon: arrow pointing right
export default () => {
  return (
    <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 5H10" stroke="currentColor" strokeWidth="2" strokeLinecap="square"/>
      <path d="M7.5 9L11.5 4.5" stroke="currentColor" strokeWidth="2"/>
      <path d="M7 1L12 5.5" stroke="currentColor" strokeWidth="2"/>
    </svg>
  )
}